import React from 'react';
import s from './TotalGroup.scss';
import classnames from 'clsx';

export enum TotalGroupDataHook {
  TotalLineTitle = 'TotalGroup.TotalLineName',
  TotalLineValue = 'TotalGroup.TotalLineValue',
  GroupTitle = 'TotalGroup.GroupTitle',
}

type RenderProp = () => React.ReactNode;
export type TotalLineProps = {
  title: string;
  className?: string;
  value: string | RenderProp;
  key: string;
  additionalAttributes?: Record<string, string>;
  labelPrefix?: React.ReactNode;
};

export const TotalGroup = ({
  dataHook,
  totals,
  title,
  suffix,
}: {
  dataHook: string;
  totals: TotalLineProps[];
  title: string;
  suffix?: React.ReactNode;
}) => {
  if (totals.length === 0) {
    return null;
  }

  if (totals.length > 1) {
    return <MultipleTotals dataHook={dataHook} totals={totals} title={title} suffix={suffix} />;
  }

  return (
    <div data-hook={dataHook} className={s.title}>
      <TotalLine total={totals[0]} />
      {suffix}
    </div>
  );
};

export const MultipleTotals = ({
  dataHook,
  title,
  totals,
  suffix,
}: {
  dataHook: string;
  title: string;
  totals: TotalLineProps[];
  suffix: React.ReactNode;
}) => {
  return (
    <div data-hook={dataHook} className={s.multipleTotalsRoot}>
      <div data-hook={TotalGroupDataHook.GroupTitle} className={s.title}>
        {title}
      </div>
      {totals.map((total) => (
        <TotalLine total={total} key={total.key} />
      ))}
      {suffix}
    </div>
  );
};

export const TotalLine = ({total}: {total: TotalLineProps}) => {
  return (
    <dl className={classnames(s.totalLine, total.className)}>
      <dt>
        {total.labelPrefix}
        <span data-hook={TotalGroupDataHook.TotalLineTitle}>{total.title}</span>
      </dt>
      <dd data-hook={TotalGroupDataHook.TotalLineValue} {...total.additionalAttributes}>
        {typeof total.value === 'string' ? total.value : total.value()}
      </dd>
    </dl>
  );
};
